import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      isSidebarMinimized: false,
    }
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },

    setSidebarMinimized(minimized: boolean) {
      this.isSidebarMinimized = minimized
    },

    initializeSidebarForMobile() {
      // Set sidebar to minimized if on mobile device
      if (typeof window !== 'undefined' && window.innerWidth <= 640) {
        this.isSidebarMinimized = true
      }
    },
  },
})
